// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuetify, {
  VProgressCircular,
  VApp,
  VBtn,
  VCheckbox,
  VContainer,
  VContent,
  VDialog,
  VFadeTransition,
  VFlex,
  VFooter,
  VForm,
  VIcon,
  VLayout,
  VList,
  VNavigationDrawer,
  VRadioGroup,
  VSelect,
  VSlider,
  VSpacer,
  VTextField,
  VToolbar,
  VTooltip,
  VCard,
  VCardTitle,
  VCardText,
  VCardActions,
  VImg,
  VDivider
} from 'vuetify/lib'
import VueTypedJs from 'vue-typed-js'

import App from './App.vue'
import router from './router'
import TumiAvatar from './components/TumiAvatar.vue'
import store from './store'
import mixpanel from './mixpanel'

Vue.component('v-form', VForm)

Vue.use(
  Vuetify, {
    components: {
      VProgressCircular,
      VApp,
      VNavigationDrawer,
      VFooter,
      VList,
      VBtn,
      VIcon,
      VToolbar,
      VDialog,
      VTooltip,
      VRadioGroup,
      VueTypedJs,
      VContainer,
      VFlex,
      VSpacer,
      VContent,
      VLayout,
      VFadeTransition,
      VForm,
      VCheckbox,
      VSelect,
      VSlider,
      VTextField,
      VCard,
      VCardTitle,
      VCardText,
      VCardActions,
      VImg,
      VDivider
    },
    theme: {
      primary: '#f11706',
      secondary: '#75ca93',
      accent: '#82B1FF',
      error: '#fff',
      info: '#2196F3',
      success: '#4CAF50',
      warning: '#FFC107'
    }
  }
)

Vue.use(VueTypedJs)
Vue.use(Vuex)
Vue.use(VueAxios, axios)

Vue.mixpanel = Vue.prototype.$mixpanel = mixpanel

Vue.config.productionTip = false
Vue.component('tumi-avatar', TumiAvatar)

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
